import { withLogo } from '@tempusfinance/common-ui';

const TokenZUSDCComponent = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      id="Livello_2"
      data-name="Livello 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1155.81 1155.81"
    >
      <g id="Livello_1-2" data-name="Livello 1">
        <g>
          <circle fill="#000" strokeWidth={0} cx="577.91" cy="577.91" r="577.91" />
          <g>
            <polygon
              fill="#00ffc3"
              strokeWidth={0}
              points="154.69 779.49 438.59 779.49 645.51 587.33 547.88 374.84 301.65 378.15 395.76 567.11 154.69 779.49"
            />
            <path
              fill="#00ffc3"
              strokeWidth={0}
              d="M895.13,646.06c0-67.19-40.31-90.23-120.94-99.82-57.59-7.68-69.11-23.04-69.11-49.92s19.2-44.15,57.59-44.15c34.55,0,53.75,11.52,63.35,40.31,1.92,5.76,7.68,9.6,13.44,9.6h30.71c7.68,0,13.44-5.76,13.44-13.43v-1.92c-7.68-42.24-42.24-74.87-86.39-78.71v-46.07c0-7.68-5.76-13.44-15.36-15.36h-28.8c-7.68,0-13.44,5.76-15.36,15.36v44.15c-57.59,7.68-94.06,46.07-94.06,94.07,0,63.35,38.39,88.3,119.02,97.91,53.75,9.6,71.03,21.12,71.03,51.83s-26.88,51.83-63.35,51.83c-49.92,0-67.19-21.12-72.95-49.92-1.92-7.68-7.68-11.52-13.43-11.52h-32.64c-7.68,0-13.43,5.76-13.43,13.44v1.92c7.68,47.99,38.39,82.54,101.74,92.15v46.07c0,7.68,5.76,13.43,15.36,15.36h28.8c7.68,0,13.44-5.76,15.36-15.36v-46.07c57.59-9.6,95.98-49.92,95.98-101.75h0Z"
            />
          </g>
        </g>
        <path
          fill="#00ffc3"
          strokeWidth={0}
          d="M578.49,1155.23c-18.18,0-32.91-14.74-32.91-32.91s14.74-32.91,32.91-32.91c69.07,0,136.05-13.52,199.09-40.18,60.91-25.76,115.61-62.65,162.6-109.63,46.99-46.99,83.87-101.69,109.63-162.6,26.66-63.04,40.18-130.02,40.18-199.09s-13.52-136.05-40.18-199.09c-25.76-60.91-62.65-115.61-109.63-162.59s-101.69-83.87-162.6-109.63c-63.04-26.66-130.02-40.18-199.09-40.18-18.18,0-32.91-14.74-32.91-32.91S560.31.59,578.49.59c77.92,0,153.53,15.27,224.73,45.38,68.75,29.08,130.49,70.7,183.5,123.71,53.01,53.01,94.63,114.75,123.71,183.5,30.11,71.2,45.38,146.81,45.38,224.73s-15.27,153.53-45.38,224.73c-29.08,68.75-70.7,130.49-123.71,183.5-53.01,53.01-114.75,94.63-183.5,123.71-71.2,30.11-146.81,45.38-224.73,45.38Z"
        />
      </g>
    </svg>
  );
};
export const TokenZUSDC = withLogo(TokenZUSDCComponent);
